export const calcSalary = (data, bigItems, smallItems) => {
	return (
		bigItems * data.delivered_commision +
		smallItems * data.additional_item_commision
	);
};
